import type { Transaction } from "@rocicorp/zero";
import { type Schema, zql } from "../generatedDrizzleSchema";

export async function stopConversationSubAgents(
  tx: Transaction<Schema>,
  conversation: { branchId: string } | { liveChatId: string },
  respondingAt: number | null
) {
  const query = zql.subAgents.where("status", "IN", ["running", "needs_input"]);
  const agents = await tx.run(
    "branchId" in conversation
      ? query.where("branchId", conversation.branchId)
      : query.where("liveChatId", conversation.liveChatId)
  );
  const now = Date.now();
  for (const agent of agents) {
    if (
      respondingAt != null &&
      agent.boundRespondingAt != null &&
      agent.boundRespondingAt > respondingAt
    )
      continue;
    await tx.mutate.subAgents.update({
      id: agent.id,
      status: "stopped",
      outcome: {
        status: "stopped",
        workflowId: agent.workflowId,
        ...(agent.branchId ? { branchId: agent.branchId } : {}),
        summary: "The workflow assistant was stopped.",
      },
      deliveryPendingAt: now,
      updatedAt: now,
    });
  }
}
